"use client";
import { createContext, useContext, useLayoutEffect, useState } from "react";
import { THEMES } from "../../styles/colorThemes";
import "./global.css";
import { ThemeName } from "./theme.css";

const allThemes = Object.keys(THEMES) as ReadonlyArray<ThemeName>;

export const ThemeContext = createContext<{
  theme: ThemeName;
  setTheme: (theme: ThemeName) => void;
}>({
  theme: allThemes[0], // Default theme should always be set
  setTheme: () => {},
});

export const useTheme = () => useContext(ThemeContext);

export const useClientEffect =
  typeof window === "undefined" ? () => {} : useLayoutEffect;

export const THEME_KEY = "ui-theme";

export const RootThemeProvider = ({
  children,
  theme: initialTheme,
}: {
  children: React.ReactNode;
  theme: ThemeName;
}) => {
  const [theme, setTheme] = useState<ThemeName>(initialTheme);

  // Update classList on theme change
  useClientEffect(() => {
    document.documentElement.classList.remove(...allThemes);
    document.documentElement.classList.add(theme);
  }, [theme]);

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
